import { createRedesignEntry } from "../redesign-page-entry";

/**
 * Lazy entry for the redesign-v1 delivery page — shell is eager; only the page body is code-split.
 */
export default createRedesignEntry(() => import("./delivery-page"), {
  testId: "rd-delivery-loading",
  shell: { activeNav: "delivery" },
});
